import { Injectable } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GolizaService {

  private _ticketsModule = 'tickets';
  private _competitorsModule = 'competitors';
  public onAttempChange: BehaviorSubject<any> = new BehaviorSubject(undefined);

  constructor(private _apiService: ApiService) { }

  public getTicketByFolio(folio: String, type:String): Promise<any> {
    return this._apiService.get(`${this._ticketsModule}/${folio}/${type}/attemps`, this.onAttempChange)
  }

  public getCompetitorByEmail(email: String): Observable<any> {
    return this._apiService.getObservable(`${this._competitorsModule}/${email}/email`);
  }

  public postCompetitor(competitor: any): Promise<any> {
    return this._apiService.post(`${this._competitorsModule}`, competitor);
  }

}